exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-preloader {\n  color: #fff;\n  font-size: 2rem;\n  position: relative;\n}\n\n.login-preloader h2 {\n  font-size: 5.5rem;\n  padding-bottom: 3rem;\n}\n\n.login-preloader .spinner {\n  margin: 0 auto;\n  margin-top: 5rem;\n  font-size: 4rem;\n}\n\n.login-preloader .button-wrap {\n  position: absolute;\n  width: 100%;\n  bottom: 3rem;\n}\n\n.login-preloader__cancel-button {\n  position: static;\n  margin-top: 5rem;\n}\n\n", ""]);

// exports
